import React, {Suspense, useEffect} from 'react';
import {Switch, Route} from "react-router-dom";
import './App.css';
import PageLoading from "../components/PageLoading";
import {useDispatch, useSelector} from "react-redux";
import {Dispatch, RootState} from "../models";
import {Spin} from "antd";
import {Helmet} from "react-helmet";
import SalesOrderPrint from "./sales-order-print";


const Login = React.lazy(() => import('./login'))
const Index = React.lazy(() => import('./index'))
const PreDealerApply = React.lazy(() => import('./pre-dealer-apply'))

function App() {

    const appDispatch = useDispatch<Dispatch>().app
    const siteConfigs = useSelector((state: RootState) => state.app.siteConfigs)

    useEffect(() => {
        appDispatch.loadSiteConfigs()
    }, [appDispatch])

    return (
        <div className="App">
            <Helmet>
                <title>{`系统后台 - ${siteConfigs?.title || ''}`}</title>
                <link rel="icon" href={siteConfigs?.favicon}/>
            </Helmet>
            {siteConfigs ? (
                <Suspense fallback={<PageLoading/>}>
                    <Switch>
                        <Route path={'/dealer/pre-apply'} component={PreDealerApply}/>
                        <Route path={'/sales/order/print/:id'} component={SalesOrderPrint}/>
                        <Route path={'/login/:next?'} component={Login}/>
                        <Route path={'/'} component={Index}/>
                    </Switch>
                </Suspense>
            ) : (
                <div style={{display: "flex", height: '100%', justifyContent: "center", alignItems: "center"}}>
                    <Spin size={"large"} spinning/>
                </div>
            )}
        </div>
    );
}

export default App;
